import angular from 'angular';

(function () {
    'use strict';

    angular.module('app', [
        // Modules "techniques"
        'app.core',
        'app.layouts',
        'app.widgets',
        'app.model',

        // Modules fonctionnels
        'app.login',
        'app.home',
        'app.principal',
        'app.kissuser',
        'app.kissseller',
        'app.kissbuyer',
        'app.kissinvoice',
        'app.kissorder',
        'app.prepasrel',
        'app.docrepo_invoice',
        'app.ladprovider',
        'app.bouser',
        'app.community',
        'app.invitedentity',
        'app.link_request',
        'app.registration_request',
        'app.payment',

        // Modules d'administration
        'app.admin',
        'epdf-app',
        'do',
    ]);
})();
